import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { AddUserList } from "../models/profile/addUserList";
import { UserSupportMap } from "../models/profile/userSupport";
import { GenericResponseDto } from "../models/generic-response.dto";

@Injectable({
  providedIn: "root",
})
export class SupportUserListService {
  private userSupportManagementBaseURL = environment.baseUrl + "/UserSupport";

  constructor(private _http: HttpClient) {}

  addUserFromTableWIS(
    payload: AddUserList
  ): Observable<GenericResponseDto<UserSupportMap>> {
    return this._http.post<GenericResponseDto<UserSupportMap>>(
      this.userSupportManagementBaseURL + "/AddWhoISupport",
      payload
    );
  }

  addUserFromTableWSM(
    payload: AddUserList
  ): Observable<GenericResponseDto<UserSupportMap>> {
    return this._http.post<GenericResponseDto<UserSupportMap>>(
      this.userSupportManagementBaseURL + "/AddWhoSupportsMe",
      payload
    );
  }
}
